// extracted by css-extract-rspack-plugin
export default {"root":"jJQ7Hw","collapsed":"y2O4bG"};